module.exports = __webpack_public_path__ + "static/media/RS232.693c359a.png";